import { render, staticRenderFns } from "./contract-group-bind-modal.component.vue?vue&type=template&id=13f4fde6&scoped=true&"
import script from "./contract-group-bind-modal.component.vue?vue&type=script&lang=ts&"
export * from "./contract-group-bind-modal.component.vue?vue&type=script&lang=ts&"
import style0 from "./contract-group-bind-modal.component.vue?vue&type=style&index=0&id=13f4fde6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f4fde6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol,VDataTable,VIcon,VRow})
